import linkData from '@/base/linkData'
import img_effects from '@/base/img_effects'
export default {
  img_effects,
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor:{
    marginTop:'0%',
    marginLeft:'30%',
    marginRight:'30%',
    marginBottom:'0%',
    textAlign: 'center'
  },
  mb_infor:{
    marginTop:'2.666%',
    marginRight:'3.733%',
    marginBottom:'1.333%',
    marginLeft:'3.733%',
    textAlign: 'center'
  },
  pc_widgets_infor:{
    marginTop:'2.666%',
    marginLeft:'3.733%',
    marginRight:'3.733%',
    marginBottom:'1.333%',
    textAlign: 'center',
    borderRadius:{
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0,
      }
    }
  },
  mb_widgets_infor:{},
  listArr:{
    url:'',
    link: linkData,
    summary:'',
    lockType:'false',
    thumbnailWidth: ''
  },
};



// WEBPACK FOOTER //
// ./src/widgets/basic_picture/style.js